export default {
  zh: {
    notFound:"Not Found",
    sendVip:"Create New Agency",
    send:"Submit",
    PleaseSelectUserId:"Please enter the user ID and search",
    PleaseSelectVIP:"Please select the VIP level",
    PleaseEnterDays:"Please enter the days of VIP",
    limit30:"The number of days cannot exceed 30",
    success:"send success",
    InputId:"Agency Name",
  },
  en: {
    notFound:"Not Found",
    sendVip:"Create New Agency",
    send:"Submit",
    PleaseSelectUserId:"Please enter the user ID and search",
    PleaseSelectVIP:"Please select the VIP level",
    PleaseEnterDays:"Please enter the days of VIP",
    limit30:"The number of days cannot exceed 30",
    success:"send success",
    InputId:"Agency Name",
  },
  ar: {
    notFound:"Not Found",
    sendVip:"Create New Agency",
    send:"Submit",
    PleaseSelectUserId:"Please enter the user ID and search",
    PleaseSelectVIP:"Please select the VIP level",
    PleaseEnterDays:"Please enter the days of VIP",
    limit30:"The number of days cannot exceed 30",
    success:"send success",
    InputId:"Agency Name",
  },
  tr: {
    notFound:"Not Found",
    sendVip:"Create New Agency",
    send:"Submit",
    PleaseSelectUserId:"Please enter the user ID and search",
    PleaseSelectVIP:"Please select the VIP level",
    PleaseEnterDays:"Please enter the days of VIP",
    limit30:"The number of days cannot exceed 30",
    success:"send success",
    InputId:"Agency Name",
  },
  pt:{
    "notFound": "Não encontrado",
    "sendVip": "Criar nova agência",
    "send": "Enviar",
    "PleaseSelectUserId": "Por favor, insira o ID do usuário e pesquise",
    "PleaseSelectVIP": "Por favor, selecione o nível VIP",
    "PleaseEnterDays": "Por favor, insira a quantidade de dias do VIP",
    "limit30": "O número de dias não pode exceder 30",
    "success": "Enviado com sucesso",
    "InputId": "Nome da agência"
    },
  id:{
    "notFound": "Tidak ditemukan",
    "sendVip": "Buat Agensi Baru",
    "send": "Kirim",
    "PleaseSelectUserId": "Silakan masukkan ID pengguna dan cari",
    "PleaseSelectVIP": "Silakan pilih level VIP",
    "PleaseEnterDays": "Silakan masukkan jumlah hari VIP",
    "limit30": "Jumlah hari tidak boleh melebihi 30",
    "success": "Berhasil dikirim",
    "InputId": "Nama Agensi"
    },
  uz:{
    "notFound": "Topilmadi",
    "sendVip": "Yangi agentlik yaratish",
    "send": "Yuborish",
    "PleaseSelectUserId": "Iltimos, foydalanuvchi identifikatorini kiriting va qidiring",
    "PleaseSelectVIP": "Iltimos, VIP darajasini tanlang",
    "PleaseEnterDays": "Iltimos, VIP kunlarini kiriting",
    "limit30": "Kunlar soni 30 dan oshmasligi kerak",
    "success": "Yuborish muvaffaqiyatli",
    "InputId": "Agentlik nomi"
    },
  ru:{
    "notFound": "Не найдено",
    "sendVip": "Создать новое агентство",
    "send": "Отправить",
    "PleaseSelectUserId": "Пожалуйста, введите идентификатор пользователя и выполните поиск",
    "PleaseSelectVIP": "Пожалуйста, выберите уровень VIP",
    "PleaseEnterDays": "Пожалуйста, введите количество дней VIP",
    "limit30": "Количество дней не может превышать 30",
    "success": "Отправка успешна",
    "InputId": "Название агентства"
   },
  fa:{
    "notFound": "یافت نشد",
    "sendVip": "ایجاد آژانس جدید",
    "send": "ارسال",
    "PleaseSelectUserId": "لطفاً شناسه کاربر را وارد کرده و جستجو کنید",
    "PleaseSelectVIP": "لطفاً سطح VIP را انتخاب کنید",
    "PleaseEnterDays": "لطفاً تعداد روزهای VIP را وارد کنید",
    "limit30": "تعداد روزها نباید از ۳۰ بیشتر باشد",
    "success": "ارسال با موفقیت",
    "InputId": "نام آژانس"
}





}



// WEBPACK FOOTER //
// src/pages/admin-control/agency_create/lang.js